
<dialog-wrapper (onClose)="emitEvent()" #dialog>

  <div class="modal-header">
    <h3 class="modal-title">{{ 'Modale.LOGIN_REQUEST_TITLE' | translate }}</h3>
    <button (click)="closeModal()"
      [attr.aria-label]="'Modale.BTN_CHIUDI' | translate"
      role="button">
        <span aria-hidden="true" class="material-symbols-sharp">close</span>
    </button>
  </div>

  <p>{{ 'Modale.LOGIN_REQUEST_DESCRIPTION' | translate }}</p>

  <div class="modal-btn-container">
    <button (click)="logoutAndKeepBrowsing()" [attr.aria-label]="" class="modal-btn keep-browsing">{{ 'Modale.LOGIN_REQUEST_KEEP_BROWSING_BTN' | translate }}</button>
    <button (click)="gotoLogin()" [attr.aria-label]="" class="modal-btn go-to-login">{{ 'Modale.LOGIN_REQUEST_GO_TO_LOGIN_BTN' | translate }}</button>
  </div>

</dialog-wrapper>
